import http from '../../src/api/axiosConfig'

class ManageEarnAdmin {

    prefix = '/v1/web/manage-earn/'

    storeEarn(data) {
        return http.post(this.prefix + 'store', data)
    }

    loadAllEarns() {
        return http.get(this.prefix + 'all')
    }

    getClientEarns(clientId) {
        return http.get(this.prefix + 'get/' + clientId)
    }

    updateEarn(data) {
        return http.post(this.prefix + 'update', data)
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ManageEarnAdmin()
